<ng-container *ngLet="criteria$ | async">
  <app-map
    #mapComponent
    class="map"
    [syncTableFilter]="true"
    [showZoomControl]="true"
    [showFilterMenu]="true"
    [clustered]="selectCatalog.cluster"
    [class.move-left]="showCard"
    (clickOnObject)="showCardClick($event)"
    [mapGeoData]="geoData$ | async"
    [dynamicDataSet]="isDynamic"
    [showDynamicInfo]="true"
  >
  </app-map>
  <app-catalog-item-card
    (backISelectedItem)="mapComponent.backSelectedItem()"
    [isMap]="true"
    class="item-card"
    *ngIf="showCard"
    [hasGeo]="false"
    (closeCard)="showCard = false; mapComponent.removeSelectedItem();"
    [fullScreen]="true"
  ></app-catalog-item-card>
</ng-container>
